import React from 'react';
import './GIEServicesContainer.css';

export default class GIEServicesContainer extends React.Component<any, any> {
    constructor(props) {
        super(props);
        this.state = {
            width: "Contrat Tranquilité",
            height: "150vh",
        }
    }

    render() {
        const {children, title, imgUrl} = this.props;
        return (
            <div>
                <div className="service-title-container">
                    <div className="service-title-image-container">
                        <img src={imgUrl} alt="informations"/>
                    </div>
                    <div className="service-title-text-container">
                        {title}
                    </div>
                </div>
                {children}
            </div>
        );
    }
}
